import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const AttachmentContainer = styled.div({
  display: 'flex',
})

export const Cont = styled.div(props => ({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '1rem',
    flex: 1
  }
}))

export const AttachmentGroup = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: '15px',

  '&:first-child': {
    marginTop: '0px',
  },

  'div.attachmentLabel': {
    display: 'flex',
    fontWeight: 'bold',
    minWidth: '100px',
    height: '40px',
    alignItems: 'center',
  },

  'div.attachmentBy': {
    display: 'flex',
    minWidth: '150px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginRight: '5px',

    span: {
      fontWeight: 'bold',
    },
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',
  },
})

export const AttachmentContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  'div:first-child>div': {
    marginTop: '0px',
  },

  'div>div': {
    marginTop: '5px',
  }
})

export const AttachmentFormContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  marginTop:'1rem',
  
  '>div:last-child':{
    marginRight:'0 !important'
  },

  '.sectionLeft': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginRight: '15px',
  },

  '.sectionRight': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  '.fileInput':{
    width:'100%'
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',
  },
})

export const FieldFileInput = styled.div((props)=>({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  marginRight: '1rem',
  
  '.oldFile':{
    '.fileUploadCellContainer':{
      //background: '#8EDD65 !important',
      //border: 'none !important',
    }
  },

  '@media only screen and (min-width: 600px)': {
    width: '45%',
  },

  '@media only screen and (min-width: 769px)': {
    width: '31%',
  },
}))